'use client';

import { c as _c } from "react/compiler-runtime";
import { faqItems } from '@/data/landing-faq.data';
import { useState, useRef } from 'react';
import { motion, AnimatePresence, useInView } from 'framer-motion';
interface FAQItemProps {
  question: string;
  answer?: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem(t0) {
  const $ = _c(22);
  const {
    question,
    answer,
    isOpen,
    onToggle
  } = t0;
  let t1;
  if ($[0] !== question) {
    t1 = <h3 className="flex-1 text-left font-medium leading-[20px] md:leading-[22px] lg:leading-[24px] text-[14px] md:text-[15px] lg:text-[16px]">{question}</h3>;
    $[0] = question;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isOpen ? 0 : 0;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      rotate: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      duration: 0.3
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isOpen) {
    t5 = isOpen ? <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="text-[var(--color-neutral-foreground)]"><path d="M4 8L12 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg> : <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="text-[var(--color-neutral-foreground)]"><path d="M8 4V12M4 8H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>;
    $[5] = isOpen;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <motion.div animate={t3} transition={t4} className="size-[16px] relative shrink-0">{t5}</motion.div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onToggle || $[11] !== t1 || $[12] !== t6) {
    t7 = <button onClick={onToggle} className="w-full flex items-center justify-between py-3 md:py-4 lg:py-[16px] px-0 cursor-pointer hover:opacity-80 transition-opacity gap-2 md:gap-4">{t1}{t6}</button>;
    $[10] = onToggle;
    $[11] = t1;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== answer || $[15] !== isOpen) {
    t8 = answer && isOpen && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: "easeInOut"
    }} className="overflow-hidden"><div className="pb-3 md:pb-4 lg:pb-[16px] pt-0 px-0"><p className="font-normal leading-[20px] md:leading-[22px] text-muted-foreground lg:leading-normal text-[13px] md:text-[13.5px] lg:text-[14px]">{answer}</p></div></motion.div>;
    $[14] = answer;
    $[15] = isOpen;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <AnimatePresence initial={false}>{t8}</AnimatePresence>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <div className="w-full border-b border-neutral-700 overflow-hidden">{t7}{t9}</div>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
const Faq = () => {
  const $ = _c(20);
  const [openIndex, setOpenIndex] = useState(null);
  const sectionRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      once: true,
      margin: "-100px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isInView = useInView(sectionRef, t0);
  let t1;
  if ($[1] !== openIndex) {
    t1 = index => {
      setOpenIndex(openIndex === index ? null : index);
    };
    $[1] = openIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const toggleFAQ = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      hidden: t2,
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
          delayChildren: 0.2
        }
      }
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const containerVariants = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0,
      y: 30
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      hidden: t4,
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.5,
          ease: "easeOut"
        }
      }
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const itemVariants = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0,
      y: 30
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      hidden: t6,
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.8,
          ease: "easeOut"
        }
      }
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const titleVariants = t7;
  const t8 = isInView ? "visible" : "hidden";
  let t9;
  if ($[9] !== t8) {
    t9 = <div className="w-full pb-8 md:pb-10 lg:pb-[44px] pt-0 px-0"><motion.h2 variants={titleVariants} initial="hidden" animate={t8} className="font-medium leading-none text-[28px] md:text-[36px] lg:text-[48px]">Perguntas frequentes</motion.h2></div>;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = isInView ? "visible" : "hidden";
  let t11;
  if ($[11] !== openIndex || $[12] !== toggleFAQ) {
    t11 = faqItems.map((faq, index_0) => <motion.div key={index_0} variants={itemVariants}><FAQItem question={faq.question} answer={faq.answer} isOpen={openIndex === index_0} onToggle={() => toggleFAQ(index_0)} /></motion.div>);
    $[11] = openIndex;
    $[12] = toggleFAQ;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t10 || $[15] !== t11) {
    t12 = <motion.div variants={containerVariants} initial="hidden" animate={t10} className="w-full flex flex-col">{t11}</motion.div>;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t12 || $[18] !== t9) {
    t13 = <section ref={sectionRef} className="w-full  flex flex-col items-center px-4 md:px-8 lg:px-[40px] py-12 md:py-16 lg:py-[96px]"><div className="flex container flex-col items-start w-full">{t9}{t12}</div></section>;
    $[17] = t12;
    $[18] = t9;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  return t13;
};
export { Faq };